import React from "react";
import AppLayout from "../components-app/AppLayout";
import OverviewList from "../components-static/OverviewList";
import {
  PageMenu,
  DeleteListItem,
  GenerateSpreadsheet,
  AddListItem,
  MobileMenu,
  Step,
  LoadGraphic,
} from "../components-static/Common";
import {
  EditSizeLabel,
  EditableBox,
  EditableSelect,
  Box,
  Select,
  TextButton,
  Button,
} from "../components-static/Input";
import { BulkAntiPassback } from "./StaffList";
import u from "../utilities/Utilities";
import PropTypes from "prop-types";
import { Spreadsheet } from "../data/Mimetypes";
import "../styles/staff-list.scss";
import moment from "moment";

export default class VisitorList extends React.Component {
  state = {
    selected: {
      tags: [],
      all: false,
      data: [],
      entryCount: 0,
    },
    pageMenuButtons: [],
    spreadsheetOptions: [],
    addError: "",
    permissions: {},
    selectMode: false,
    isSuperUser: u.getSuperUser(),
  };

  pageData = {
    title: "Visitors",
    permission: "combined",
    permissionField: "visitor",
    url: "/visitor-list",
    scrollAnchor: u.getKey(),
  };

  listData = {
    deleteURL: "/api/delete-visitor-entries",
    spreadsheetURL: "/api/generate-visitor-spreadsheet",
    overviewURL: "/api/get-all-visitors",
    overviewLabel: "visitor-list",
    orderByField: "visitorName",
    orderByType: "ascending",
    numRows: 20,
    checkboxPermissions: {},
    listOptions: [
      { label: "Tag Setting", ref: "macro", enabled: true, type: "list" },
    ],
  };

  componentDidMount = () => {
    const permissions = u.getPermissions("combined");
    this.setState({
      permissions: permissions,
      pageMenuButtons: [
        {
          label: "Add",
          mobileLabel: "Add Visitor",
          ref: "add",
          image: "/images/page-menu/add.png",
          title: "Add new visitor",
          enabled: permissions.create == 2,
        },
        {
          label: "Template",
          mobileLabel: "Download Template",
          ref: "download",
          image: "/images/page-menu/template.png",
          title: "Download bulk add template",
          enabled: permissions.create == 2,
          onClick: this.onDownloadTemplate,
        },
        {
          label: "Delete",
          mobileLabel: "Delete Visitor",
          ref: "delete",
          image: "/images/page-menu/delete.png",
          title: "Delete selected visitor",
          enabled: permissions.visitor == 2,
        },
        {
          label: "Spreadsheet",
          mobileLabel: "Generate Spreadsheet",
          ref: "spreadsheet",
          image: "/images/page-menu/spreadsheet.png",
          title: "Generate spreadsheet from selection",
          enabled: true,
        },
        {
          label: "Unlock",
          mobileLabel: "Unlock Passback",
          ref: "unlock",
          image: "/images/page-menu/unlock.png",
          title: "Unlock user's anti passback",
          enabled: this.state.isSuperUser,
          padding: "5px",
        },
      ],
    });
  };

  onMenuOptionClicked = (ref, show, mobileNav) => {
    if (mobileNav) {
      const toggle = this.mobileSelect != ref;
      this.setState({
        selectMode: (ref == "spreadsheet" || ref == "delete") && toggle,
      });
      this.mobileSelect = toggle ? ref : null;
      for (var i = 0; i < mobileNav.length; i++) {
        const r = mobileNav[i].ref;
        const show = r == ref;

        if (show) {
          if (mobileNav[i].onClick) {
            mobileNav[i].onClick();
          } else if (mobileNav[i].type == "list") {
            this.refs["overview"].triggerListOptions(r, toggle);
          } else {
            this.refs[r].show(toggle);
          }
        } else {
          if (mobileNav[i].onClick) {
          } else if (mobileNav[i].type == "list") {
            this.refs["overview"].triggerListOptions(r, false);
          } else {
            this.refs[r].show(false);
          }
        }
      }
    } else {
      this.setState({
        selectMode: (ref == "spreadsheet" || ref == "delete") && show,
      });
      this.refs[ref].show(show);
    }
  };

  onToggleForm = (ref, show) => {
    this.refs["menu"].toggleForm(ref, show);
    this.mobileSelect = show ? ref : null;
  };

  onSelectChange = (selected) => {
    this.setState({ selected: selected });
  };

  onRefreshList = () => {
    this.refs["overview"].onRefreshList();
  };

  onContentGrabbed = (content) => {
    this.setState({ spreadsheetOptions: content.spreadsheetOptions });
  };

  onDownloadTemplate = () => {
    u.post({
      url: "/api/get-add-visitor-template",
      data: {},
      success: (callback) => {
        u.download(
          callback.filename,
          callback.filestamp,
          () => {},
          (error, status) => {
            this.setState({ error: error });
          }
        );
      },
      error: (error, status) => {
        this.setState({ error: error });
      },
    });
  };

  render = () => {
    const mobileMenu = this.state.pageMenuButtons.concat(
      this.listData.listOptions
    );
    return (
      <AppLayout
        title={this.pageData.title}
        requiredPermission={this.pageData.permission}
        requiredField={this.pageData.permissionField}
        url={this.pageData.url}
      >
        <div className="page-error">{this.state.error}</div>
        <PageMenu
          id={this.pageData.scrollAnchor}
          title={this.pageData.title}
          ref="menu"
          buttons={this.state.pageMenuButtons}
          onMenuOptionClicked={this.onMenuOptionClicked}
        >
          <AddEntry
            scrollAnchor={this.pageData.scrollAnchor}
            ref="add"
            reference="add"
            onToggleForm={this.onToggleForm}
            onRefreshList={this.onRefreshList}
          />
          <DeleteListItem
            scrollAnchor={this.pageData.scrollAnchor}
            ref="delete"
            reference="delete"
            url={this.listData.deleteURL}
            selected={this.state.selected}
            onToggleForm={this.onToggleForm}
            onRefreshList={this.onRefreshList}
          />
          <GenerateSpreadsheet
            scrollAnchor={this.pageData.scrollAnchor}
            ref="spreadsheet"
            url={this.listData.spreadsheetURL}
            options={this.state.spreadsheetOptions}
            reference="spreadsheet"
            selected={this.state.selected}
            onToggleForm={this.onToggleForm}
          />
          <BulkAntiPassback
            scrollAnchor={this.pageData.scrollAnchor}
            ref="unlock"
            type="visitor"
            reference="unlock"
            selected={this.state.selected}
            onToggleForm={this.onToggleForm}
            onRefreshList={this.onRefreshList}
          />
        </PageMenu>
        <OverviewList
          ref="overview"
          selectMode={this.state.selectMode}
          url={this.listData.overviewURL}
          label={this.listData.overviewLabel}
          numRows={this.listData.numRows}
          orderByField={this.listData.orderByField}
          orderByType={this.listData.orderByType}
          onSelectChange={this.onSelectChange}
          registerReference={this.registerReference}
          onContentGrabbed={this.onContentGrabbed}
          onMutatedChange={this.onMutatedChange}
          checkboxPermissions={this.listData.checkboxPermissions}
        >
          {(content, index, onChange, onContentChange, registerRef) => {
            return (
              <VisitorItem
                key={index}
                index={index}
                content={content}
                onChange={onChange}
                onContentChange={onContentChange}
                registerReference={registerRef}
                permissions={this.state.permissions}
                isSuperUser={this.state.isSuperUser}
              />
            );
          }}
        </OverviewList>
        <MobileMenu content={mobileMenu} onClick={this.onMenuOptionClicked} />
      </AppLayout>
    );
  };
}

class VisitorItem extends React.Component {
  state = {
    error: "",
    step: "view",
    loading: false,
    loadText: "",
  };

  onUnlockPassback = () => {
    this.setState({ loading: true, loadText: "Unlocking passback..." });
    u.post({
      url: "/api/unlock-passback",
      data: {
        type: "visitor",
        id: this.props.content.visitorID,
        tenantID: this.props.content.tenantID,
      },
      success: () => {
        this.setState({ step: "confirm-remove", loading: false });
      },
      error: (error) => {
        this.setState({ error: error });
      },
    });
  };

  render = () => {
    const content = this.props.content;
    const edit = this.props.permissions.visitor == 2;
    const url = "/api/update-visitor-info";
    const index = this.props.index + "";
    const id = content.visitorID;
    const cargoLift = content.cargoLiftFloors
      ? content.cargoLiftFloors.map((block) => {
          if (block.floors.length == 0) {
            return "None";
          }
          let floors = "";
          for (var i = 0; i < block.floors.length; i++) {
            floors = floors + (i == 0 ? "" : " / ") + block.floors[i];
          }
          return block.block + " " + floors;
        })
      : [];

    return (
      <div style={{ textAlign: "center" }}>
        <LoadGraphic active={this.state.loading} text={this.state.loadText} />
        <div className="list-segment-error">{this.state.error}</div>

        <Step active={this.state.step == "view"}>
          <div className="list-segment extended" style={{ textAlign: "left" }}>
            <div className="list-segment-item">
              <div className="list-segment-label">Visitor Name:</div>
              <div className="list-segment-input">
                <EditableBox
                  label="Visitor Name"
                  field="visitorName"
                  values={{ value: content.visitorName, enabled: false }}
                  rules={{ nullText: "None" }}
                  index={index}
                  id={id}
                  url={url}
                  onChange={this.props.onChange}
                />
              </div>
            </div>
            <div className="list-segment-item">
              <div className="list-segment-label">Email:</div>
              <div className="list-segment-input">
                <EditableBox
                  label="Email"
                  field="email"
                  type="email"
                  values={{ value: content.email, enabled: false }}
                  rules={{ required: true, nullText: "None" }}
                  index={index}
                  id={id}
                  url={url}
                  onChange={this.props.onChange}
                />
              </div>
            </div>
            <div className="list-segment-item">
              <div className="list-segment-label">Contact Number:</div>
              <div className="list-segment-input">
                <EditableBox
                  label="Contact Number"
                  field="contactNumber"
                  values={{ value: content.contactNumber, enabled: false }}
                  rules={{ nullText: "None" }}
                  index={index}
                  id={id}
                  url={url}
                  onChange={this.props.onChange}
                />
              </div>
            </div>
          </div>
          <div className="list-segment extended" style={{ textAlign: "left" }}>
            <div className="list-segment-item">
              <div className="list-segment-label">Company Name:</div>
              <div className="list-segment-input">
                <EditSizeLabel nullText="None">
                  {content.companyName}
                </EditSizeLabel>
              </div>
            </div>
            <div className="list-segment-item">
              <div className="list-segment-label">Current Location:</div>
              <div className="list-segment-input">
                <EditSizeLabel>{content.location}</EditSizeLabel>
              </div>
            </div>
            <div className="list-segment-item">
              <div className="list-segment-label">Cargo Lift Access:</div>
              <div className="list-segment-input">
                <EditSizeLabel nullText="None">
                  {cargoLift.filter((item) => {
                    return item != "None";
                  }).length > 0
                    ? cargoLift
                        .filter((item) => {
                          return item != "None";
                        })
                        .map((item, index) => {
                          return (
                            <div
                              key={index}
                              style={{ marginTop: index > 0 ? "5px" : "0px" }}
                            >
                              {item}
                            </div>
                          );
                        })
                    : "None"}
                </EditSizeLabel>
              </div>
            </div>
          </div>
          {this.props.isSuperUser ? (
            <div className="list-segment-buttons">
              <Button
                type="medium"
                onClick={() => {
                  this.setState({ step: "remove-passback" });
                }}
              >
                Unlock Anti-Passback
              </Button>
            </div>
          ) : (
            ""
          )}
        </Step>

        <Step active={this.state.step == "remove-passback"}>
          <div className="list-segment-details" style={{ padding: "20px 0" }}>
            <h2 className="text-negative">Confirm Unlock Anti-Passback</h2>
            <div>
              Please ensure that the user has been briefed that he will be
              locked out of the turnstiles if he does not exit after he enters
            </div>
            <div className="list-segment-buttons">
              <Button
                type="medium"
                onClick={() => {
                  this.setState({ step: "view" });
                }}
              >
                Back
              </Button>
              <Button type="medium" onClick={this.onUnlockPassback}>
                Confirm
              </Button>
            </div>
          </div>
        </Step>

        <Step active={this.state.step == "confirm-remove"}>
          <div className="list-segment-details" style={{ padding: "20px 0" }}>
            <h2 className="text-emphasis">
              Anti-Passback Unlocked Successfully
            </h2>
            <div className="list-segment-button">
              <Button
                type="medium"
                onClick={() => {
                  this.setState({ step: "view" });
                }}
              >
                Back
              </Button>
            </div>
          </div>
        </Step>
      </div>
    );
  };
}

class AddEntry extends React.Component {
  state = {
    error: "",
    entryData: {},
  };

  addData = {
    addType: 2,
    addURL: "/api/add-visitor",
    bulkAddURL: "/api/add-bulk-visitor",
  };

  show = (show) => {
    this.refs[this.props.reference].show(show);
  };

  onChangeEntry = (value, label, index, option) => {
    let entryData = this.state.entryData;
    entryData[label] = value;
    this.setState({ entryData: entryData });
  };

  onAddEntry = () => {
    this.setState({ error: "" });
    const inputs = ["visitorName", "email", "contactNumber"];
    for (var i = 0; i < inputs.length; i++) {
      const current = this.refs[inputs[i]].validate();
      if (!current.valid) {
        this.setState({ error: current.value });
        return 0;
      }
    }

    this.refs[this.props.reference].onValidated(this.state.entryData);
  };

  onComplete = () => {
    this.setState({ error: "", entryData: {} });
  };

  render = () => {
    const content = this.state.entryData;
    return (
      <AddListItem
        scrollAnchor={this.props.scrollAnchor}
        ref={this.props.reference}
        reference={this.props.reference}
        addType={this.addData.addType}
        index={this.addData.addIndex}
        label={this.addData.label}
        bulkURL={this.addData.bulkAddURL}
        filetypes={Spreadsheet}
        url={this.addData.addURL}
        onToggleForm={this.props.onToggleForm}
        onRefreshList={this.props.onRefreshList}
        onComplete={this.onComplete}
      >
        <div style={{ textAlign: "center" }}>
          <h3>Complete the following to continue</h3>
          <div className="segment-error">{this.state.error}</div>
          <div className="segment-content">
            <div className="segment-margin-area">
              <div className="segment-full-item">
                <div className="segment-item-label">Visitor Name:</div>
                <div className="segment-item-input">
                  <Box
                    ref="visitorName"
                    label="Visitor Name"
                    field="visitorName"
                    values={{ value: content.visitorName }}
                    rules={{ required: true }}
                    onChange={this.onChangeEntry}
                  />
                </div>
              </div>
              <div className="segment-full-item">
                <div className="segment-item-label">Block:</div>
                <div className="segment-item-input">
                  <Box
                    ref="block"
                    label="Block"
                    field="block"
                    values={{ value: content.block }}
                    rules={{ placeholder: "Optional" }}
                    onChange={this.onChangeEntry}
                  />
                </div>
              </div>
              <div className="segment-full-item">
                <div className="segment-item-label">Email:</div>
                <div className="segment-item-input">
                  <Box
                    ref="email"
                    label="Email"
                    type="email"
                    field="email"
                    values={{ value: content.email }}
                    rules={{ required: true }}
                    onChange={this.onChangeEntry}
                  />
                </div>
              </div>
              <div className="segment-full-item">
                <div className="segment-item-label">Contact Number:</div>
                <div className="segment-item-input">
                  <Box
                    ref="contactNumber"
                    label="Contact Number"
                    field="contactNumber"
                    values={{ value: content.contactNumber }}
                    rules={{ placeholder: "Optional", mobileNumber: true }}
                    onChange={this.onChangeEntry}
                  />
                </div>
              </div>
            </div>

            <div className="segment-margin-area" style={{ fontSize: "0.9em" }}>
              <TextButton
                onClick={() => {
                  this.refs[this.props.reference].onBulkUpload();
                }}
              >
                Add Bulk Entries
              </TextButton>
            </div>

            <div className="segment-margin-area">
              {u.isMobileDevice() ? (
                <Button
                  type="medium"
                  onClick={() => {
                    this.props.onToggleForm(this.props.reference, false);
                  }}
                >
                  Cancel
                </Button>
              ) : (
                ""
              )}
              <Button type="medium" onClick={this.onAddEntry}>
                Add Entry
              </Button>
            </div>
          </div>
        </div>
      </AddListItem>
    );
  };
}
AddEntry.propTypes = {
  scrollAnchor: PropTypes.string,
  onToggleForm: PropTypes.func.isRequired,
  onRefreshList: PropTypes.func.isRequired,
};
